"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const react_1 = require("react");
const utils_1 = require("../utils");
const OrderButton = ({ resellerName, isLoading = false, onClick }) => {
    const label = (0, react_1.useMemo)(() => (0, utils_1.formatOrderButtonLabel)(resellerName), [resellerName]);
    return ((0, jsx_runtime_1.jsx)(flora_react_1.Button, Object.assign({ isFull: true, onClick: onClick, variant: "conversion", leftIcon: (0, jsx_runtime_1.jsx)(flora_react_icons_1.SocialWhatsappIcon, { size: 16 }), loadingText: "Enviando", isLoading: isLoading, "autotagging-flora": "on", css: {
            '> span[class]': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textAlign: 'left',
                display: 'block',
            },
        } }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Text, { children: label }) })));
};
exports.OrderButton = OrderButton;
